import React, { useState } from "react";
import { InputNumber, Button, message, Form } from "antd";
import { ApiRequest } from "../../../services/api/api";
import { getUserId } from "../../../services/lib/utils/auth.utils";

interface ProductionOverrunEditDialogProps {
  productId: number;
  productName: string;
  currentQuantity: number;
  onSuccess: () => void;
  onCancel: () => void;
}

const ProductionOverrunEditDialog: React.FC<ProductionOverrunEditDialogProps> = ({
  productId,
  productName,
  currentQuantity,
  onSuccess,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const newQuantity = values.newQuantity;

      if (newQuantity === currentQuantity) {
        message.warning("新数量与当前数量相同，无需更新");
        return;
      }

      setLoading(true);

      // 获取当前用户ID（employeeId）
      const employeeId = getUserId();

      if (!employeeId || isNaN(employeeId)) {
        message.error("无法获取用户信息，请重新登录");
        setLoading(false);
        return;
      }

      await ApiRequest({
        otherUrl: "ProductionOverrunReport/UpdateProductionOverrunQuantity",
        method: "post",
        data: {
          productId: productId,
          newQuantity: newQuantity,
          employeeId: employeeId,
        },
        isShowSpinner: true,
      });

      message.success("更新成功");
      onSuccess();
    } catch (error: any) {
      console.error("Failed to update production overrun quantity", error);
      message.error(error?.response?.data?.message?.message || "更新失败，请重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "1.5rem" }}>
      <Form
        form={form}
        layout="vertical"
        initialValues={{ newQuantity: currentQuantity }}
      >
        <Form.Item label="产品名称 / Product Name">
          <span style={{ fontSize: "1rem", fontWeight: 500 }}>{productName}</span>
        </Form.Item>

        <Form.Item label="当前累计多出数量 / Current Total Overrun Quantity">
          <span style={{ fontSize: "1rem", color: "#1890ff" }}>{currentQuantity}</span>
        </Form.Item>

        <Form.Item
          label="新累计多出数量 / New Total Overrun Quantity"
          name="newQuantity"
          rules={[
            { required: true, message: "请输入新数量" },
            { type: "number", min: 0, message: "数量不能为负数" },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            min={0}
            precision={0}
            placeholder="请输入新数量"
          />
        </Form.Item>

        <Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
            <Button onClick={onCancel} disabled={loading}>
              取消 / Cancel
            </Button>
            <Button type="primary" onClick={handleSubmit} loading={loading}>
              确认 / Confirm
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ProductionOverrunEditDialog;

